import { Link } from 'react-router-dom';
import bannerImg from '../images/teamcover.png';
import bg from './../images/btcl-100-club.png';

function Btcl100Club() {
    const isMobile = window.innerWidth <= 768;

    const styles = {
        banner: {
            width: '100%',
            maxWidth: '1232px',
            height: isMobile ? '160px' : '256px',
            background: `url(${bannerImg})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
            margin: '32px auto 0 auto',
            borderRadius: '0px',
        },
        bannerOverlay: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'linear-gradient(180deg, rgba(6, 13, 138, 0.4) 0%, rgba(4, 9, 96, 0.7) 100%)',
        },
        bannerTitle: {
            fontFamily: 'var(--fontAnton)',
            color: '#FFFFFF',
            fontSize: isMobile ? '36px' : '64px',
            textTransform: 'uppercase',
            position: 'relative',
            zIndex: 1,
            margin: 0,
            letterSpacing: '2px',
            textShadow: '0 10px 30px rgba(0,0,0,0.5)',
        },
        container: {
            maxWidth: '1100px',
            margin: '0 auto',
            padding: isMobile ? '40px 16px' : '64px 24px',
            display: 'flex',
            flexDirection: 'column',
            gap: '40px',
        },
        card: {
            background: '#FFFFFF',
            borderRadius: '0px',
            padding: '40px',
            borderBottom: '1px solid #eee',
        },
        cardTitle: {
            fontFamily: 'var(--fontAnton)',
            color: '#060D8A',
            fontSize: '24px',
            textTransform: 'uppercase',
            letterSpacing: '1px',
            marginBottom: '20px',
        },
        cardText: {
            fontFamily: 'var(--fontInter)',
            color: '#444',
            fontSize: '16px',
            lineHeight: '1.8',
            margin: 0,
        },
        list: {
            fontFamily: 'var(--fontInter)',
            color: '#444',
            fontSize: '16px',
            lineHeight: '2',
            paddingLeft: '20px',
            margin: '20px 0 0 0',
        },
        bottomBanner: {
            background: `url(${bg}) no-repeat`,
            height: isMobile ? 'auto' : '320px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: "center",
            alignItems: 'center',
            width: '100%',
            maxWidth: '1232px',
            margin: '2rem auto',
            padding: '60px 24px',
            borderRadius: "0px",
            backgroundSize: 'cover',
            position: 'relative',
            color: 'white',
            textAlign: 'center',
            boxSizing: 'border-box',
        }
    };

    const handleScrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div style={{ backgroundColor: '#FFFFFF', minHeight: '100vh', paddingTop: '112px' }}>
            {/* Hero Banner */}
            <div style={styles.banner}>
                <div style={styles.bannerOverlay}></div>
                <h1 style={styles.bannerTitle}>BTCL 100 CLUB</h1>
            </div>

            <div style={styles.container}>
                <div style={styles.card}>
                    <h2 style={styles.cardTitle}>What’s in it for you?</h2>
                    <p style={styles.cardText}>
                        Once you’re a subscribed member of the 100 Club, you’ll be part of the BTCL family and one of the first to find out about the latest goings on with the league.
                        What’s more, each member will receive:
                    </p>
                    <ul style={styles.list}>
                        <li>Free entry to the BTCL Annual Cricketers Night</li>
                        <li>The BTCL’s quarterly newsletter</li>
                        <li>A page dedicated to you in our annual Souvenir Magazine, where you can post an advertisement for your business, favourite charity or a memorial for a loved one</li>
                        <li>You’ll also be entered into our annual prize draw to be in with a chance of winning up to £1000*</li>
                    </ul>
                </div>

                <div style={styles.card}>
                    <h2 style={styles.cardTitle}>How will this benefit the BTCL?</h2>
                    <p style={styles.cardText}>
                        The funds we raise through this programme will mainly be used to further the development of junior cricket opportunities in UK and some will be used to fund Cricket development projects in our Homeland. The funds we raise may also be matched by other sports associations and charities, helping us achieve more of our goals.
                    </p>
                </div>

                <div style={styles.card}>
                    <h2 style={styles.cardTitle}>How do I join the Club?</h2>
                    <p style={styles.cardText}>
                        All you have to do if complete the application form with a few personal details and agree to pay the subscription fees of £200 per year for a period of five years. You’ll become a member as soon as we receive either full payment or are notified that arrangements to pay by Direct Debit or Standing Order have been made.
                    </p>
                </div>

                <div style={styles.bottomBanner}>
                    <div style={{
                        position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
                        background: 'rgba(4, 9, 96, 0.6)', zIndex: 0
                    }}></div>
                    <p style={{
                        color: 'white', textAlign: 'center', position: 'relative',
                        zIndex: 1, fontFamily: 'var(--fontInter)', fontSize: isMobile ? '14px' : '18px',
                        lineHeight: 1.6, maxWidth: '800px', marginBottom: '32px'
                    }}>
                        The perfect opportunity has come up for you to play a bigger part in our
                        community and win some great prizes too. By becoming a 100 club member
                        you get the prestige of being a contributor to the success of our league as
                        well as gain experience of what we do.
                    </p>
                    <Link to="/contact" onClick={handleScrollToTop} style={{
                        backgroundColor: 'var(--yellow)', color: '#000', textDecoration: 'none',
                        fontFamily: 'var(--fontInter)', fontWeight: 700, fontSize: '14px',
                        padding: '12px 40px', borderRadius: '30px', width: 'fit-content',
                        position: 'relative', zIndex: 1, textTransform: 'uppercase', letterSpacing: '1px'
                    }}>Contact Us</Link>
                </div>
            </div>
        </div>
    );
}

export default Btcl100Club;
